import { useState, useEffect } from "react";
import { getPotionTicketState } from "utils/api";

export const usePotionTicketState = (soulId) => {
  const [ticketState, setTicketState] = useState(null);
  const [hasPurchased, setHasPurchased] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (!soulId) return;

    const fetchTicketState = async () => {
      try {
        const data = await getPotionTicketState(soulId);
        setTicketState(data);
        setHasPurchased(true);
      } catch (error) {
        if (error.status === 404) {
          setHasPurchased(false);
          setTicketState(null);
        } else {
          setIsError(true);
        }
      } finally {
        setIsLoading(false);
      }
    };

    fetchTicketState();
  }, [soulId]);

  return { ticketState, isLoading, isError, hasPurchased };
};

export default usePotionTicketState;
